const customerOpinions = {
    init() {
        const $slider = jQuery('.customers-opinions__slider');
        if (!$slider.length) return;

        $slider.slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 400,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        jQuery(window).on('load', () => $slider.slick('setPosition'));
        document.addEventListener('lazyloaded', (event) => {
            if (event.target.closest('.customers-opinions')) {
                $slider.slick('setPosition');
            }
        });

        // Custom arrow navigation
        jQuery('.customers-opinions__arrow--prev').on('click', function () {
            $slider.slick('slickPrev');
        });

        jQuery('.customers-opinions__arrow--next').on('click', function () {
            $slider.slick('slickNext');
        });
    }
};

export default customerOpinions;

